export default {"src":"/blogs/_next/static/media/linkedin.f61e1160.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};